function BookCard({ book }) {
    try {
        const handleDownload = () => {
            try {
                const byteCharacters = atob(book.file.split(',')[1]);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'application/pdf' });

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${book.title}.pdf`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            } catch (error) {
                console.error('下載錯誤:', error);
                alert('下載失敗，請稍後再試。');
            }
        };

        return (
            <div className="book-card" data-name="book-card">
                <img 
                    src={book.coverImage} 
                    alt={book.title} 
                    className="book-image"
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://via.placeholder.com/300x400?text=無封面';
                    }}
                    data-name="book-cover"
                />
                <div className="book-info">
                    <h3 className="book-title" data-name="book-title">{book.title}</h3>
                    <p className="text-sm text-gray-500 mb-1" data-name="book-category">
                        {book.category}
                    </p>
                    <p className="text-sm text-gray-500 mb-2" data-name="book-date">
                        {new Date(book.uploadedAt).toLocaleDateString('zh-TW')}
                    </p>
                    <p className="book-description" data-name="book-description">
                        {book.description}
                    </p>
                    <button 
                        onClick={handleDownload} 
                        className="btn btn-primary w-full mt-4"
                        data-name="download-button"
                    >
                        <i className="fas fa-download mr-2"></i>
                        下載 PDF
                    </button>
                </div>
            </div>
        );
    } catch (error) {
        console.error('書籍卡片錯誤:', error);
        reportError(error);
        return null;
    }
}

export default BookCard;